export const limitMeasureIds = [356, 359, 362, 3591] as const;
type TLimitMeasureIds = typeof limitMeasureIds[number];

export default TLimitMeasureIds;
